export enum TicketField {
    title = 'title',
    ownerIds = 'ownerIds',
    status = 'status',
    category = 'category',
    company = 'company',
    responsibleUserId = 'responsibleUserId',
    createdAt = 'createdAt'
}
